/**
 * 特集商品提案状況確認(取引先用)画面の特集商品提案状況一覧クラス
 *
 * @export FeatureRequestInfo
 * @class FeatureRequestInfo
 */
export class FeatureRequestInfo {
    public check = false;
    public statusName: string = <string>''; // 表示するステータス名、商品選定済みフラグをもとに設定
    constructor(
      public OrderCode: string,
      public CatalogIdName: string,
      public MediumType: string,
      public MediumName: string,
      public FeatureCode: string,
      public FeatureName: string,
      public SelectionFlag: number,
      public Remarks: string,
    ) {}
  }
  
  